import { useQueryFlags } from 'scripts/hooks/useQueryFlags'
import { getFormattedTimestamp } from 'utils/helpers';

interface TimestampProps {
    timestamp: string | Date | undefined;
}

const Timestamp = ({ timestamp }: TimestampProps): JSX.Element => {
    const { timeline: isTimeStampVisible } = useQueryFlags();
    if (isTimeStampVisible && timestamp) {
        return (
            <div className="user_date_stamp" style={{ minWidth: '115px' }}>
                {getFormattedTimestamp(timestamp)}
            </div>
        )
    }
    return <></>;
}

export default Timestamp
